module.exports = __webpack_public_path__ + "img/Guirlande_lumineuse.0f9c11b.png";